module.exports = __webpack_public_path__ + "assets/img/Gymnasium.e679c3ca.jpg";